import styled from 'styled-components';
import { MenuItem } from '@mui/material';
import {
  OPTION_ITEM_HEIGHT,
  OPTION_ITEM_HEIGHT_WITH_DESCRIPTION,
} from '../constants';
import { componentToken } from '../../../style/utils';

const MenuItemStyled = styled(MenuItem)<{
  $multiple?: boolean;
  $hasDescription?: boolean;
  selected?: boolean;
}>`
  min-height: 0;
  height: ${({ $hasDescription }) =>
    $hasDescription
      ? `${OPTION_ITEM_HEIGHT_WITH_DESCRIPTION}px`
      : `${OPTION_ITEM_HEIGHT}px`};
  padding: ${({ $multiple }) =>
    $multiple
      ? componentToken('dropDown.menuItem.padding')
      : componentToken('dropDown.menuItem.paddingLg')};
  border-radius: ${componentToken('dropDown.menuItem.borderRadius')};

  .MuiTypography-root {
    font-size: ${componentToken('dropDown.menuItem.fontSize')};
  }

  :hover {
    background: ${componentToken('dropDown.menuItem.hoverBackground')};
  }

  &.Mui-selected {
    background: none;

    :hover {
      background: ${componentToken(
        'dropDown.menuItem.selectedHoverBackground',
      )};
    }
  }
`;

export default MenuItemStyled;
